import React from "react";
import { TableHeaderColumnType } from "app/components/Table/types";
import {
  FormControlLabel,
  Grid,
  Radio,
  TableRow,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { selectAnswer } from "app/containers/Questions/redux/selector";
import { MODES } from "utils/constants";
import { useTranslation } from "react-i18next";
import { actions } from "app/containers/Questions/redux/slice";
import { MultiAnswerTypes, SingleAnswerTypes } from "app/containers/Questions/types";


const MultiSelectAnswerTypes = ({
  mode,
}: {
  mode: MODES;
}) => {
  const answer = useSelector(selectAnswer);
  const value: MultiAnswerTypes = answer.multi_select?.[0]?.answer as MultiAnswerTypes || 'ONLY_TEXT';

  const { t } = useTranslation();
  const disabled = mode === MODES.VIEW 
  const dispatch = useDispatch();
  const onSelect = (
    value: MultiAnswerTypes
  ) => {
    dispatch(
      actions.setMultiSelectAnswerTypeAnswer({
        value,
      })
    );
  };
  return (
    <Grid display={'flex'} alignItems={'center'} mt={'30px'}>

      <FormControlLabel
        onClick={() => {
          if(disabled){return}
          onSelect("ONLY_TEXT");
        }}
        disabled={disabled}
        value={'ONLY_TEXT'}
        control={<Radio size="small" checked={value === 'ONLY_TEXT'} />}
        label={
          <Typography>
            {t("QUESTIONS.OPTION_ANSWER_TYPES.ONLY_TEXT")}
          </Typography>
        }
       
      />
      <FormControlLabel
        value={'ONLY_IMAGES'}
        disabled={disabled}
        onClick={() => {
          if(disabled){return}
          onSelect("ONLY_IMAGES");
        }}
        control={<Radio size="small" checked={value === 'ONLY_IMAGES'} />}
        label={
          <Typography>
            {t("QUESTIONS.OPTION_ANSWER_TYPES.ONLY_IMAGES")}
          </Typography>
        }
        
      />
      <FormControlLabel
        disabled={disabled}
        onClick={() => {
          if(disabled){return}
          onSelect("TEXT_WITH_IMAGES");
        }}
        value={"TEXT_WITH_IMAGES"}
        control={<Radio size="small" checked={value === 'TEXT_WITH_IMAGES'} />}
        label={
          <Typography>
            {t("QUESTIONS.OPTION_ANSWER_TYPES.TEXT_WITH_IMAGES")}
          </Typography>
        }
      />

    </Grid>
  );
};

export default MultiSelectAnswerTypes;
